export default __webpack_public_path__ + "static/media/logo-leclerc.768b5860.svg";